document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cts').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-cts-tab]');
    var panels = root.querySelectorAll('[data-cts-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-index');

        tabs.forEach(function (t) {
          var active = t.getAttribute('data-index') === index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var active = p.getAttribute('data-index') === index;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      });
    });

    root.querySelectorAll('[data-cts-panel]').forEach(function (panel) {
      var track = panel.querySelector('[data-cts-track]');
      var carousel = panel.querySelector('[data-cts-carousel]');
      var prevBtn = panel.querySelector('[data-cts-prev]');
      var nextBtn = panel.querySelector('[data-cts-next]');
      if (!track || !carousel) return;

      var pos = 0;

      function cardStep() {
        var card = track.querySelector('.cts__card');
        if (!card) return 0;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap || style.columnGap || 28);
        return card.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - carousel.clientWidth);
      }

      function update() {
        pos = Math.max(0, Math.min(pos, maxScroll()));
        track.style.transform = 'translateX(-' + pos + 'px)';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          pos -= cardStep() * 2;
          update();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          pos += cardStep() * 2;
          update();
        });
      }

      window.addEventListener('resize', update);
    });
  });
});
